import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { ModalGenericoModel } from "src/app/shared/models/modal.model";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { DetalleSolicitudService } from "../../containers/bandeja-principal/funcionario/detalle-solicitud/detalle-solicitud.service";
import { ListItemSimplified } from "src/app/shared/models/ListItemSimplified.model";
import { EstadosSolicitud } from "src/app/shared/enumeraciones/estados-solicitud.enum";

@Component({
  selector: "app-modal-editar-estado",
  templateUrl: "./modal-editar-estado.component.html",
  styleUrls: ["./modal-editar-estado.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalEditarEstadoComponent implements OnInit {
  @Input()
  estados: Array<any>;
  @Input()
  descripcion: string;
  selectedStatusId: string = null;
  headers: Array<string>;
  modalGenerico: ModalGenericoModel;
  formDatos: FormGroup;
  itemEstados: ListItemSimplified;
  motivo: Array<any>;
  estado_devuelto = EstadosSolicitud.Devuelto;
  devuelto = false;
  @ViewChild("texto", { static: true }) texto: ElementRef;
  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private detalleServices: DetalleSolicitudService
  ) {}

  ngOnInit() {
    this.modalGenerico = {
      titulo: "Cambiar estado solicitud",
    };
    this.headers = ["Código", "Descripción"];
    this.formulario();
    if (!this.descripcion || this.descripcion === "NULL") {
      this.texto.nativeElement.innerHTML = "<p>Sin datos relacionados</p>";
    } else {
      this.texto.nativeElement.innerHTML = this.descripcion.substr(
        0,
        this.descripcion.length
      );
      console.log("descripción X",  this.descripcion);
    }
    this.detalleServices.getMotivos().subscribe((resultado) => {
      if (resultado.result) {
        this.motivo = resultado.data;
      }
    });
  }

  setSelectedStatus(value: string): void {
    this.devuelto = false;
    if (this.estados && value) {
      const status: ListItemSimplified = this.estados.find(
        (s) => s.estado_solicitud_id === value
      );
      if (status) {
        this.formDatos.patchValue({
          estado_descripcion: status.descripcion,
        });
      } else {
        this.formDatos.value.estado_descripcion = "";
      }

      if (this.formDatos.value.estado_posterior_id === this.estado_devuelto) {
        this.devuelto = true;
        this.formDatos = this.formBuilder.group({
          estado_posterior_id: [
            this.formDatos.value.estado_posterior_id,
            Validators.required,
          ],
          estado_descripcion: [this.formDatos.value.estado_descripcion],
          motivo_devolucion_id: ["", Validators.required],
          observaciones: ["", Validators.required],
        });
      } else {
        this.formDatos = this.formBuilder.group({
          estado_posterior_id: [
            this.formDatos.value.estado_posterior_id,
            Validators.required,
            console.log("validación", this.formDatos),
          ],
          estado_descripcion: [this.formDatos.value.estado_descripcion],
          motivo_devolucion_id: [""],
          observaciones: ["", Validators.required],
        });
      }
    }
  }

  formulario() {
    this.formDatos = this.formBuilder.group({
      estado_posterior_id: ["", Validators.required],
      estado_descripcion: [""],
      motivo_devolucion_id: [""],
      observaciones: ["", Validators.required],
    });
  }

  confirm(): void {
    if (this.activeModal && this.formDatos.value) {
      this.activeModal.close(this.formDatos.value);
    }
  }

  dismiss(): void {
    if (this.activeModal) {
      this.activeModal.dismiss();
    }
  }
  
}
